module.exports = __webpack_public_path__ + "static/img/client_img1.74b475f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/VXImage/client_img1.svg
// module id = EygD
// module chunks = 0